import React from "react";
import styled from "styled-components";

import namemark from "../../Resources/Images/namemark.png";
import { useHistory } from "react-router-dom";

const NameMark = styled.img`
  height: 22px;
  width: auto;
`;

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  height: 50px;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Header = () => {
  const history = useHistory();
  return (
    <HeaderWrapper>
      <NameMark src={namemark} />
    </HeaderWrapper>
  );
};

export default Header;
